/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'screenshot': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" _stroke="#C4FFF9" stroke-width="6.25" stroke-linecap="round" stroke-linejoin="round" d="M18.75 18.75h112.501v112.501h-112.5z"/><path pid="1" d="M37.5 50.01c0 3.445 2.795 6.24 6.258 6.24a6.242 6.242 0 0 0 6.24-6.24c0-3.463-2.795-6.258-6.24-6.258A6.25 6.25 0 0 0 37.5 50.01" _fill="#C4FFF9" fill-rule="nonzero"/><path pid="2" _stroke="#C4FFF9" stroke-width="6.25" stroke-linejoin="round" d="M37.5 93.75L62.502 68.75l18.75 18.75 18.75-24.997 12.499 12.499"/></g>'
  }
})
